import { bool, node, shape, string } from 'prop-types';
import React from 'react';
import Badge from '../IDSBadge';

const RegionLabel = ({ useIdsBadge, ...props }) => {
  return useIdsBadge ? (
    <Badge
      type="secondary"
      text={`${props.Content.Translations.regionlabel} ${props.Content.CurrentRegionName}`}
    />
  ) : (
    <span className="regionlabel">
      {props.Content.Translations.regionlabel} {props.Content.CurrentRegionName}
    </span>
  );
};

RegionLabel.propTypes = {
  useIdsBadge: bool,
  Content: shape({
    Translations: shape({
      regionlabel: string,
    }),
    CurrentRegionName: node,
  }),
};

export default RegionLabel;
